import styled from "styled-components";

export const SocialMediaContainer = styled.div`
display: flex;
justify-content: center;
position: absolute;
button{
    margin: 0 2px;
}
`